import React from "react";
import Button from "@material-ui/core/Button";
import Arrow from "@material-ui/icons/ArrowForwardIos";
import { Link } from "react-router-dom";

function SideContent(props) {
  return (
    <div className="container">
      <div className="side-image">
        <img src={props.side_image} alt="" />
        <img className="top dots" src={props.top} alt="" />
        <img className="side dots" src={props.side} alt="" />
      </div>

      <div className="side-content">
        <h1 className="about-header">{props.title}</h1>
        <p className="about-para">{props.para}</p>
        {props.btn !== "" && (
          <Button className="btn" variant="contained" color="primary">
            <Link to={"/about"}>Learn more</Link>
            <Arrow />
          </Button>
        )}
      </div>
    </div>
  );
}

export default SideContent;
